import React from 'react';
import { motion } from 'framer-motion';
import { UserMinus, ClockAlert, TrendingUp, SearchX } from 'lucide-react';
export function HiringChallenges() {
  const challenges = [{
    icon: <UserMinus className="w-6 h-6 text-slate-400 group-hover:text-coral transition-colors" data-id="element-128" />,
    title: 'Interview Fatigue',
    desc: 'Spending hours interviewing candidates who look great on paper but lack the right skills or cultural fit.'
  }, {
    icon: <ClockAlert className="w-6 h-6 text-slate-400 group-hover:text-pink transition-colors" data-id="element-129" />,
    title: 'Roles Stay Open Too Long',
    desc: 'Critical positions remain unfilled for months, putting strain on your existing team and slowing growth.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-slate-400 group-hover:text-purple transition-colors" data-id="element-130" />,
    title: 'Rising Hiring Costs',
    desc: 'Traditional agencies charge massive fees, while local talent demands increasingly unsustainable salaries.'
  }, {
    icon: <SearchX className="w-6 h-6 text-slate-400 group-hover:text-navy transition-colors" data-id="element-131" />,
    title: 'Screening Takes Time',
    desc: 'Sifting through hundreds of unqualified resumes takes focus away from your core business objectives.'
  }];
  return <section className="py-24 bg-white" data-id="element-132">
      <div className="max-w-7xl mx-auto px-6" data-id="element-133">
        <div className="max-w-3xl mb-16" data-id="element-134">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold leading-tight text-navy" data-id="element-135">
            Most Companies Aren't Struggling to Find Talent...
            <span className="block mt-4" style={{
            color: '#F35BC8'
          }} data-id="element-136">
              They're Struggling to Find the Right Talent.
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-137">
          {challenges.map((challenge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 rounded-3xl bg-slate-50 border border-slate-100 hover:bg-white hover:shadow-soft-lg hover:border-slate-200 transition-all duration-300" data-id="element-138">
              <div className="flex items-start gap-6" data-id="element-139">
                <div className="w-12 h-12 rounded-2xl bg-white border border-slate-100 shadow-sm flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300" data-id="element-140">
                  {challenge.icon}
                </div>
                <div data-id="element-141">
                  <h3 className="text-xl font-bold mb-2 text-navy" data-id="element-142">
                    {challenge.title}
                  </h3>
                  <p className="text-navy/70 leading-relaxed" data-id="element-143">
                    {challenge.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}